import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IBlokTest } from './models';

interface IPrivateTestState {
  data?: IBlokTest | null;
  isRunning: boolean;
}

const initialState: IPrivateTestState = {
  data: null,
  isRunning: false
};

const privateTestSlice = createSlice({
  name: 'privateTest',
  initialState,
  reducers: {
    setPrivateTestData(state, action: PayloadAction<IBlokTest>) {
      state.data = action.payload;
    },
    startTimer(state) {
      state.isRunning = true;
    },
    stopTimer(state) {
      state.isRunning = false;
    }
  }
});

export const { setPrivateTestData, startTimer, stopTimer } = privateTestSlice.actions;
export const privateTestReducer = privateTestSlice.reducer;
